// Design reference for event illustrations (matches `aspect-[1280/486]` used
// in Tailwind thumbnails). Shared across web and mobile so the decision is
// identical on both platforms.
export const EVENT_IMAGE_REFERENCE_WIDTH = 1280;
export const EVENT_IMAGE_REFERENCE_HEIGHT = 486;

export const shouldUseCoverFit = (
  naturalWidth: number,
  naturalHeight: number,
): boolean =>
  naturalWidth >= EVENT_IMAGE_REFERENCE_WIDTH &&
  naturalHeight >= EVENT_IMAGE_REFERENCE_HEIGHT;
